// PanierSlice.js
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import axios from "axios";
import _ from "lodash";
import { OrderType } from "../../../Types/Entites/Orders/OrderType";

interface UpdateOrderParams {
  orderId?: string;
  status: string | null;
  paidProducts?: any;
  vendeur : String | null;
}


/**
 * list  of reservation by organisation.
 * @public
 */
export const findReservationsByOrganisationApi = createAsyncThunk(
  "reservation/findReservationsByOrganisationApi",
  async (data: any, { rejectWithValue, dispatch }) => {
    const {organisation_id,index}=data
    try {
      const response = await axios.get(
        `reservation/findReservationsByOrganisationApi/${organisation_id}/${index}`
      );
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  }
);


/**
 * list  of reservation by organisation.
 * @public
 */
export const findReservationByorderId = createAsyncThunk(
  "reservation/findReservationByorderId",
  async (orderid: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(
        `reservation/findReservationByorderId/${orderid}`
      );
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  }
);


export const ValidationeservationApi = createAsyncThunk(
  "reservation/ValidationeservationApi",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.put(
        `reservation/ValidationeservationApi`,data
      );
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  }
);
export const confirmReservationApi = createAsyncThunk(
  "reservation/confirmReservationApi",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.put(
        `reservation/confirmReservationApi`,data
      );
      return response.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue({
        success: false,
        message: error.response.data.message,
      });
    }
  }
);
interface OrdersState {
  listReservations: any[];
  selectedOrder:   OrderType | null;
  totalPages:any;
  currentpage:any;
  selectedReservation:any

}

const initialState: OrdersState = {
  listReservations: [],
  selectedOrder:null,
  totalPages:null,
  currentpage:null,
  selectedReservation:null
};

export const ReservationSlice = createSlice({
  name: "Reservation",
  initialState,
  reducers: {
    SelectReservation: (
      state,
      action: PayloadAction<{
        order_id: string;
      }>
    ) => {
      const { order_id } = action.payload;
      const order = state.listReservations.find((item) => item._id === order_id);
      if (!order) {
        return state;
      }

      return {
        ...state,
        selectedOrder: order.order,
      };
    },
  
  },

  extraReducers: (builder) => {
 
    builder.addCase(findReservationsByOrganisationApi.fulfilled, (state, action) => {
   
      return {
        ...state,
        listReservations: action.payload.data,
        totalPages:action.payload.totalPages,
        currentpage:action.payload.currentPage,
        
      };
    });
    builder.addCase(findReservationByorderId.fulfilled, (state, action) => {
   
      return {
        ...state,
        selectedReservation: action.payload,
       
        
      };
    });
  },
});
export const { SelectReservation } =
ReservationSlice.actions;
export const ListReservations = (state: RootState) => state.reservation.listReservations;
export const SelectedReservation = (state: RootState) => state.reservation.selectedReservation;

export const currentPage = (state: RootState) => state.reservation.currentpage;
export const totalPages = (state: RootState) => state.reservation.totalPages;


export default ReservationSlice.reducer;
